<template>
  <div class="CoreTechnology">
    <div class="main">
      <p class="title">核心技术</p>

      <ul class="items">
        <li class="item" v-for="technology,index in technologys">
          <div class="img">
            <img :src="technology.imgUrl" />
          </div>
          <p class="text">{{technology.text}}</p>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'CoreTechnology',
    data() {
      return {
        technologys: [
          {imgUrl: require("@/assets/imgs/ic-tec-logo-spark.png"),text:"基于spark大数据组件实现对海量数据快速的规整处理能力，能够快速的对几十G数据进行规整处理。"},
          {imgUrl: require("@/assets/imgs/ic-tec-logo-avro.png"),text:"基于Avro格式的数据存储技术对数据进行有效存储，灵活存储，向上兼容，扩展方便，读取快速。"},
          {imgUrl: require("@/assets/imgs/ic-tec-logo-tgi.png"),text:"基于TGI(Target Group Index)的数据分析方法，对用户画像数据进行灵活分析处理。挑选出最优质的受众特征。"},
          {imgUrl: require("@/assets/imgs/ic-tec-logo-elastic.png"),text:"采用elasticsearch构建营销中心的用户库，并提供友好的操作界面供运营人员操作，方便维护用户库。"},
        ]
      }
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  .CoreTechnology {
    width: 100%;

    .main {
      width: 1200px;
      margin: 0 auto;
      p {
        margin: 0;
      }
      >.title {
        height:50px;
        font-size:40px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin-top: 39px;
      }

      .items {
        margin: 70px 0 0;
        display: flex;
        justify-content: center;
        padding-bottom: 96px;

        .item {
          width:244px;
          height:320px;
          background:rgba(238,238,238,1);
          border:1px solid rgba(204,204,204,1);
          box-shadow:0px 10px 10px 0px rgba(170,170,170,0.2);
          border-radius:8px;
          list-style: none;
          margin: 0 25px;

          >.img {
            width: 244px;
            height: 140px;
            background:rgba(255,255,255,1);
            border-radius:8px 8px 0px 0px;
            box-sizing: border-box;
            padding-top: 8px;

            img {
              width: 220px;
              display: block;
              margin: 0 auto;
            }
          }

          >.text {
            font-size:20px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            line-height:32px;
            margin: 0 14px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Technology_Services/CoreTechnology.vue